/**
 * Парсер объекта данных.
 *
 */
export default {

  /**
   * Получение названия.
   *
   * @param data
   * @returns {*}
   */
  getName( data ) {

    if ( !data || typeof data.name !== 'string' ) {
      console.error( 'Ошибка парсинга. Не найдено название.' )
      return ''
    }

    return data.name
  },

  /**
   * Получение названия.
   *
   * @param data
   * @returns {*}
   */
  getDescription( data ) {

    if ( !data || ( data.description !== null && typeof data.description !== 'string' ) ) {
      console.error( 'Ошибка парсинга. Не найдено описание.' )
      return ''
    }

    return data.description
  },

  /**
   * Получение списка данных.
   *
   * @param data
   * @returns {*}
   */
  getList( data ) {

    if ( !data || typeof data.options !== 'object' || !Array.isArray( data.options.list ) ) {
      console.error( 'Ошибка парсинга. Не найден список данных.' )
      return []
    }

    return data.options.list.map( item => item.value )
  },

  /**
   * Получение списка данных через API.
   *
   * @param data
   * @returns {*}
   */
  getApiList( data ) {

    if ( !data || !Array.isArray( data.list ) ) {
      console.error( 'Ошибка парсинга. Не найден список данных.' )
      return []
    }

    return data.list
  },

  /**
   * Получение значения по умолчанию.
   *
   * @param data
   * @returns {*}
   */
  getDefault( data ) {

    if ( !data || typeof data.options !== 'object' || typeof data.options.default !== 'number' ) {
      console.error( 'Ошибка парсинга. Не найдено значение по умолчанию.' )
      return 0
    }

    return data.options.default
  },

  /**
   * Получение значения по умолчанию через API.
   *
   * @param data
   * @returns {*}
   */
  getApiDefault( data ) {

    if ( !data || typeof data.default !== 'number' ) {
      console.error( 'Ошибка парсинга. Не найдено значение по умолчанию.' )
      return 0
    }

    return data.default
  },

  /**
   * Получение адреса метода API.
   *
   * @param data
   * @returns {*}
   */
  getUrl( data ) {

    if ( !data || typeof data.options !== 'object' || typeof data.options.url !== 'string' ) {
      console.error( 'Ошибка парсинга. Не найден адрес метода API.' )
      return null
    }

    return data.options.url
  }
}



// WEBPACK FOOTER //
// ./src/apps/bpm/components/parsers/list_parser.js